import React from "react";
import { Badge, Card, IconGlyph, SectionLabel } from "./ProfileDashboardUI";

const MetricCard = ({ icon, value, label, sub, trend, trendVariant, iconBg, tokens }) => (
  <Card tokens={tokens} className="p-4">
    <div
      className="w-7 h-7 rounded-lg flex items-center justify-center mb-2.5"
      style={{ backgroundColor: iconBg }}
    >
      <IconGlyph name={icon} className="w-3.5 h-3.5" color={tokens.ink} />
    </div>
    <div className="text-[11px] font-medium mb-1" style={{ color: tokens.faint }}>{label}</div>
    <div className="text-[22px] font-semibold tracking-tight" style={{ color: tokens.ink }}>{value}</div>
    <div className="text-[11px] mt-1 mb-2" style={{ color: tokens.faint }}>{sub}</div>
    {trend && <Badge variant={trendVariant} tokens={tokens}>{trend}</Badge>}
  </Card>
);

const SavingsBenchmarks = ({ stats, tokens }) => {
  const { savings } = stats;
  const hasPositiveSavings = Number(savings.totalRaw || 0) >= 0;
  const cards = [
    {
      icon: "trend",
      iconBg: tokens.successLight,
      label: "Total savings",
      value: savings.total,
      sub: "First-round L1 minus final awarded amount",
      trend: savings.savingsRfqCount > 0 ? "Closed RFQs with quotation history" : "No closed RFQ savings yet",
      trendVariant: hasPositiveSavings ? "green" : "red",
    },
    {
      icon: "file",
      iconBg: tokens.primaryLight,
      label: "Avg. quotes / RFQ",
      value: savings.avgQuotes,
      sub: "Quotes submitted per floated RFQ",
      trend: "Submitted quotes / floated RFQs",
      trendVariant: "blue",
    },
    {
      icon: "users",
      iconBg: tokens.accentLight,
      label: "Vendor participation",
      value: `${savings.vendorParticipation}%`,
      sub: "Invited vendors who submitted quotes",
      trend: "Submitted / invited vendors",
      trendVariant: "green",
    },
    {
      icon: "clock",
      iconBg: tokens.warnLight,
      label: "Avg. cycle time",
      value: `${savings.cycleTimeDays}d`,
      sub: "RFQ creation to sending for Approval",
      trend: savings.cycleTimeDelta,
      trendVariant: "amber",
    },
  ];

  return (
    <>
      <SectionLabel tokens={tokens}>Savings & benchmarks</SectionLabel>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5">
        {cards.map((card) => <MetricCard key={card.label} {...card} tokens={tokens} />)}
      </div>
    </>
  );
};

export default SavingsBenchmarks;
